import React from 'react'
import { Outlet } from 'react-router-dom'
import AppSidebar from '../components/seller/AppSidebar'
import AppHeader from '../components/seller/AppHeader'
import AppFooter from '../components/seller/AppFooter'
import Header from '../components/buyer/Header1'

const SellerLayout = () => {
  return (
    <div className="wrapper d-flex flex-column min-vh-100">
      <Header />
      <AppSidebar />
      <div className="wrapper d-flex flex-column flex-grow-1">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <Outlet /> {/* This is where routed pages like Dashboard, Orders, Products appear */}
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default SellerLayout
